export enum ColumnNames {
  Id = 'Id',
  Name = 'Name',
  IsActive = 'IsActive',
  CreateDate = 'CreateDate',
  OverwrittenActive = 'OverwrittenActive',
  OverwrittenInactive = 'OverwrittenInactive',
}

export interface GetAliiFeatureByNameResponse {
  name: string;
  description: string;
  isGloballyEnabled: boolean;
  isAdminUser: boolean;
  clientOverrides: AdminClientOverride[];
}

export interface AdminClientOverride {
  clientId: number;
  clientName: string | null;
  isActive: boolean;
}

export interface PutAliiFeatureRequest {
  name: string;
  isActive: boolean;
  description: string;
  bridgeClientAliiFeatures: BridgeClient[];
}

export type BridgeClient = {
  id: number | undefined;
  clientName: string;
  clientId: number;
  isActive: boolean;
};
